import {
  IconBookmark,
  IconBuildings,
  IconCoil,
  IconEnergyCircle,
  IconInfo,
  IconMeter,
  IconPencil,
  IconPenSquare,
  IconPlug,
  IconPower,
  IconRuler,
  IconSearch,
  IconShare,
  IconShareGray,
  IconSignal,
  IconTools,
  IconUpload,
} from '@assets/images/icon';
import { IconTopology } from '@assets/images/main';
import { accessAuto1, accessAutoMain, accessPro1, accessProMain, accesscontroller1, accesscontrollerMain } from '@assets/images/main/access/product';
import { vehicleTrackingKit1, vehicleTrackingKit5, yardTrackingKit1, yardTrackingKit4 } from '@assets/images/main/outdoor';

export default {
  a: [
    { text: '技术类型', icon: IconInfo },
    { text: '定位精度', icon: IconSignal },
    { text: '传输周期', icon: IconUpload },
    { text: '集成结构', icon: IconTopology },
    { text: '电源输入', icon: IconPlug },
    { text: '推荐环境', icon: IconBookmark },
    { text: '主要特点', icon: IconPencil },
    { text: '外部集成', icon: IconShare },
  ],

  b: [
    { text: '基于GNSS的GPS定位' },
    { text: '±3米' },
    { text: '最多每分钟30次' },
    { text: 'GPS设备（LTE） → ORBRO服务器' },
    { text: 'USB-C' },
    { text: '车辆追踪，资产定位' },
    { text: '单一设备即可获取位置信息' },
    { text: '提供API' },
  ],

  c: [
    { text: '基于LoRA的GPS信号接收' },
    { text: '±3米' },
    { text: '最多每分钟120次' },
    { text: 'GPS标签 → LoRA接收器 → ORBRO服务器' },
    { text: 'PoE' },
    { text: '堆场、港口、物流中心、施工现场等' },
    { text: '可在特定区域接收多个标签信号，<br/>无需通信费用即可使用' },
    { text: '提供API（实时事件/位置/状态集成）' },
  ],

  spec: [
    {},

    {
      image: vehicleTrackingKit5,
      link: '/outdoor/gps',
      title: 'GPS设备',
      desc: '',
    },

    {
      image: yardTrackingKit4,
      link: '/outdoor/lora',
      title: 'GPS标签（LoRA）',
      desc: '',
    },
  ],
};
